import React from 'react'
import moment from 'moment'

const DeliveryDetailsReportColumnModel = () => {
  const modelArr: any[] = []

  modelArr.push(
    {
      title: 'Packing Slip No',
      field: 'packingSlipNo',
      render: (rowData: any) => rowData.packingSlipNo || ''
    },
    {
      title: 'Order No',
      field: 'orderNo',
      hidden: true, // 默认隐藏
      render: (rowData: any) => rowData.orderNo || ''
    },
    {
      title: 'Delivered Date',
      field: 'deliveredDate',
      render: (rowData: any) => rowData.deliveredDate ? moment.utc(rowData.deliveredDate).local().format('DD/MM/YYYY') : ''
    },
    {
      title: 'Customer',
      field: 'customer',
      render: (rowData: any) => rowData.customer || ''
    },
    {
      title: 'Delivery Address',
      field: 'deliveryAddress',
      render: (rowData: any) => (
        <div style={{ maxWidth: '300px', whiteSpace: 'normal', wordBreak: 'break-word' }}>
          {rowData.deliveryAddress || ''}
        </div>
      )
    },
    {
      title: 'Product Code',
      field: 'productCode',
      render: (rowData: any) => rowData.productCode || ''
    },
    {
      title: 'Product Name',
      field: 'productName',
      render: (rowData: any) => (
        <div style={{ maxWidth: '250px', whiteSpace: 'normal', wordBreak: 'break-word' }}>
          {rowData.productName || ''}
        </div>
      )
    },
    {
      title: 'Carton Qty',
      field: 'cartonQty',
      type: 'numeric',
      render: (rowData: any) => rowData.cartonQty || 0
    },
    {
      title: 'Delivery Method',
      field: 'deliveryMethod',
      render: (rowData: any) => rowData.deliveryMethod || ''
    }
  )

  return modelArr
}

export default DeliveryDetailsReportColumnModel
